import React from "react";
import IChildren from "./interfaces/IChildren";
import { connect } from "react-redux";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import * as appInsights from "./appInsights";

interface IProps extends IChildren {
    aiConnectionString: string;
}


const TelemetryProvider = ({ children, aiConnectionString }: IProps) => {
    if (aiConnectionString) {
       appInsights.init(aiConnectionString);
    }

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
}

export default connect()(withAITracking(appInsights.reactPlugin, TelemetryProvider));